import { useNavigate } from "react-router-dom";
import { useCallback } from "react";
import { styled } from "@mui/material/styles";
import MuiAppBar, { AppBarProps as MuiAppBarProps } from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import { BasicMenu } from "@/components/molecules/BasicMenu";
import { Title, QA, MAIN, DEV } from "@/common/CommonConstants";
import { useAuthUser } from "@/hooks/useAuthUser";
import Cookies from "js-cookie";
import { CookieKey } from "@/models/auth";
import { MenuProp } from "@/models/common";
import { useSetting } from "@/context";

type Props = {
  open: boolean;
  toggleDrawer: any;
};
const drawerWidth: number = 240;

interface AppBarProps extends MuiAppBarProps {
  open?: boolean;
}

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})<AppBarProps>(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

export default function ApplicationBar(props: Props) {
  const { user } = useAuthUser();
  const { routeTitleHeader } = useSetting();
  const navigate = useNavigate();

  const logout = useCallback(() => {
    let gxoperator: string | undefined = Cookies.get(CookieKey.gxoperator);
    Cookies.remove(CookieKey.gxoperator);
    if (gxoperator) {
      navigate("/login");
      return;
    }
    let operator: string | undefined = Cookies.get(CookieKey.operator);
    if (operator) {
      navigate("/dashboard");
      return;
    }
    navigate("/login");
  }, [navigate]);

  const menuProps: MenuProp[] = [
    {
      label: "ログアウト",
      onClick: logout,
    },
  ];
  return (
    <AppBar
      style={
        process.env.REACT_APP_PROD_URL === MAIN
          ? { backgroundColor: "#1FB63F" }
          : process.env.REACT_APP_PROD_URL === QA
            ? { backgroundColor: "rgba(46, 204, 113, 1)" }
            : process.env.REACT_APP_PROD_URL === DEV
              ? { backgroundColor: "#4e4bed" }
              : undefined
      }
      position="absolute"
      open={props.open}
    >
      <Toolbar
        sx={{
          pr: "24px",
        }}
      >
        <IconButton
          edge="start"
          color="inherit"
          aria-label="open drawer"
          onClick={props.toggleDrawer}
          sx={{
            marginRight: "36px",
            ...(props.open && { display: "none" }),
          }}
        >
          <MenuIcon />
        </IconButton>
        <Typography
          component="h1"
          variant="h6"
          color="inherit"
          noWrap
          sx={{ flexGrow: 1 }}
        >
          {routeTitleHeader || Title}
        </Typography>
        <BasicMenu title={user?.name || ""} menuProps={menuProps} />
      </Toolbar>
    </AppBar>
  );
}
